import { useTheme, useMediaQuery } from '@mui/material';

/**
 * True on phone-sized screens (below the `sm` breakpoint, 600px).
 *
 * The same breakpoint the layout already switches on: below it the sidebar becomes a temporary
 * drawer, so anything else that changes shape for a phone should agree with that rather than
 * pick its own number and disagree at some widths.
 *
 * Used for choices that cannot be expressed in `sx` — a dialog going full screen is a prop, not
 * a style. Prefer responsive `sx` values (`{ xs: 1, sm: 3 }`) wherever the difference is only
 * visual, because those need no JavaScript and no re-render on resize.
 */
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
};
